import { Component, OnInit, OnDestroy } from '@angular/core';
import { ListadaAgrupada, ConfigService } from '../../../infrastructure/services/config.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';

@Component({
  templateUrl: './configurar.subscription.component.html'
})
export class ConfigurarSubscriptionComponent implements OnInit {
  codOrganization:string;
  codSubscription: string;
  codNegocio: string;
  codProducto: string;
  grupos: Observable<ListadaAgrupada[]>;
  cargando: Boolean = true;

  constructor(private aRoute: ActivatedRoute, private configService: ConfigService) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
        // Parametros URL
        this.codOrganization = params['codorganizacion'];
        this.codSubscription = params['codsistema'];
        this.codNegocio = params['codnegocio'];
        this.codProducto = params['codproducto'];

        // Obtenemos la configuracion para el nivel
        this.grupos = this.configService.getConfiguracion(
          this.codOrganization,
          this.codSubscription, 
          this.codNegocio, 
          this.codProducto).
        map(res => res.filter(x => x.subcat === null));
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/subscription/configurar.subscription.component.ts